/**
 * Created by maxime on 2017-05-09.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LogFactory } from '../modules/config/logging';
import ConfigsManager from '../modules/config/configs';
import { removeUnwantedDevices, filterDevices, tryMedia, releaseStream, getDevices, areDeviceListsEqual } from './devices.utils';
import { from, of, timer } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
var Logger = LogFactory('DevicesManager');
var DevicesManager = /** @class */ (function () {
    function DevicesManager(store, deviceActions) {
        var _this = this;
        this.store = store;
        this.deviceActions = deviceActions;
        this._currentDevices = [];
        this._deviceChangeSubscription = null;
        this._deviceChangeSubscription = timer(ConfigsManager.AVAILABLE_DEVICE_POLL_INITIAL_DELAY, ConfigsManager.AVAILABLE_DEVICES_POLL_INTERVAL_TIME).pipe(mergeMap(function () {
            return from(_this.updateAvailableDevices()).pipe(catchError(function (e) {
                Logger.error('Error:', e);
                return of(null);
            }));
        })).subscribe();
    }
    DevicesManager.prototype.unsubscribeDeviceChange = function () {
        if (this._deviceChangeSubscription) {
            Logger.log('Unsubscribing from device change subscription');
            this._deviceChangeSubscription.unsubscribe();
            this._deviceChangeSubscription = null;
        }
    };
    DevicesManager.prototype.updateAvailableDevices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var devices, ioDevices;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getDevices()];
                    case 1:
                        devices = _a.sent();
                        ioDevices = this.store.getState().ioDevices;
                        if (ioDevices && ioDevices.allDevices) {
                            devices = filterDevices(ioDevices.allDevices, devices);
                        }
                        devices = removeUnwantedDevices(devices);
                        if (!areDeviceListsEqual(devices, this.currentDevices)) {
                            this._currentDevices = devices;
                            this.store.dispatch(this.deviceActions.setAvailable(devices));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DevicesManager.prototype.accessInputDevices = function (mediaStreamConstraints) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.releaseInputDevices();
                        _a = this;
                        return [4 /*yield*/, tryMedia(mediaStreamConstraints)];
                    case 1:
                        _a._mediaStream = _b.sent();
                        return [2 /*return*/, this._mediaStream];
                }
            });
        });
    };
    DevicesManager.prototype.releaseInputDevices = function () {
        if (this._mediaStream) {
            releaseStream(this._mediaStream);
            this._mediaStream = undefined;
        }
    };
    Object.defineProperty(DevicesManager.prototype, "currentDevices", {
        get: function () {
            return this._currentDevices;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevicesManager.prototype, "selectedInputDevice", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.selectedInputDevice;
            }
            return null;
        },
        set: function (device) {
            this.store.dispatch(this.deviceActions.setAudioInput(device));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevicesManager.prototype, "selectInputReady", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.selectInputReady;
            }
            return true;
        },
        set: function (state) {
            this.store.dispatch(this.deviceActions.setInputReady(state));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevicesManager.prototype, "selectedVideoInputDevice", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.selectedVideoInputDevice;
            }
            return null;
        },
        set: function (device) {
            this.store.dispatch(this.deviceActions.setVideoInput(device));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevicesManager.prototype, "selectedVideoInputBitRate", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.selectedVideoInputBitRate;
            }
            return 500;
        },
        set: function (bitRate) {
            this.store.dispatch(this.deviceActions.setVideoInputBitRate(bitRate));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevicesManager.prototype, "selectedOutputDevice", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.selectedOutputDevice;
            }
            return null;
        },
        set: function (device) {
            this.store.dispatch(this.deviceActions.setAudioOutput(device));
        },
        enumerable: true,
        configurable: true
    });
    DevicesManager.prototype.setSelectedLabelledOutputDevice = function (label, device) {
        this.store.dispatch(this.deviceActions.setAudioLabelledOutput(label, device));
    };
    Object.defineProperty(DevicesManager.prototype, "screenShare", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.screenShare;
            }
            return null;
        },
        set: function (screen) {
            this.store.dispatch(this.deviceActions.setScreenShare(screen));
        },
        enumerable: true,
        configurable: true
    });
    DevicesManager.prototype.getSelectedLabelledOutputDevice = function (label) {
        var state = this.store.getState().ioDevices;
        if (state) {
            var labelledOutputDeviceInfo = state.labelledOutputDevices.get(label);
            if (labelledOutputDeviceInfo) {
                return labelledOutputDeviceInfo.selectedOutputDevice;
            }
        }
        return null;
    };
    Object.defineProperty(DevicesManager.prototype, "videoConstraints", {
        get: function () {
            var state = this.store.getState().ioDevices;
            if (state) {
                return state.videoTrackConstraints;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return DevicesManager;
}());
export { DevicesManager };
export default DevicesManager;
//# sourceMappingURL=devices.manager.js.map